import { defineMessages } from 'react-intl';

const messages = defineMessages({
  //section 1
  section1: {
    id: 'lQRjLu',
    defaultMessage: 'Identify & Protect',
  },
  section1_ques: {
    id: 'NPWSKI',
    defaultMessage: 'How exposed to risk do you think you are?',
  },
  section1_ans1: {
    id: 'zArQLV',
    defaultMessage: 'Not at all',
  },
  section1_ans1_desc: {
    id: '2CclQf',
    defaultMessage:
      'If you believe you do not have current exposure to cyber threats, the following questions can help you verify this and our team can help ensure that you can take steps to maintain this position in the future. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section1_ans2: {
    id: 'HS1aFA',
    defaultMessage: 'Somewhat',
  },
  section1_ans2_desc: {
    id: 'bSyUvm',
    defaultMessage:
      'The following questions can help you to validate your understanding of exposure and identify areas of improvement. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section1_ans3: {
    id: 'AkIyKO',
    defaultMessage: "I don't know",
  },
  section1_ans3_desc: {
    id: 'qOrP/5',
    defaultMessage:
      'The following questions can help you to establish your current cyber resilience posture and identify initial areas for improvement. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section1_ans4: {
    id: 'ozJDHv',
    defaultMessage: 'Quite',
  },
  section1_ans4_desc: {
    id: 'hwbNOI',
    defaultMessage:
      'The following questions can help you to better understand and improve your ability to identify threats and to protect your organisation from them. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section1_ans5: {
    id: 'FM97dD',
    defaultMessage: 'Very',
  },
  section1_ans5_desc: {
    id: 'A4kjmD',
    defaultMessage:
      'The following questions can help you discover how you can begin to improve your ability to identify threats and to protect from them. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section1_subsec1_quesName: {
    id: 'izvHMl',
    defaultMessage: 'Identify',
  },
  section1_subsec1_feature_desc: {
    id: 'sSRqcC',
    defaultMessage:
      'Threat identification is crucial for building robust cyber resilience, as it enables you to proactively address potential vulnerabilities before they can be exploited, thereby minimizing the impact of security breaches and ensuring business continuity.  Our study looks at the areas of Asset Management, Business Environment, Governance, Risk Assessment and Risk Management Strategy.',
  },
  section1_subsec1_ques1: {
    id: 'Hke+9n',
    defaultMessage:
      'To what extent is there a process in place to manage and prioritize internal IT resources that support your critical business services?',
  },
  section1_subsec1_ques2: {
    id: 'COKSWw',
    defaultMessage:
      'To what extent has a risk management strategy been developed with a defined MTD (Maximum Tolerable Downtime) objective?',
  },
  section1_subsec2_quesName: {
    id: '8JGaVE',
    defaultMessage: 'Protect',
  },
  section1_subsec2_feature_desc: {
    id: 'znXgBu',
    defaultMessage:
      'Implementing robust security measures is crucial for maintaining a strong cyber resilience posture, as it helps safeguard sensitive data, protect against potential threats, and ensure business continuity during times of crisis or disruption.  Our study looks at areas such as Identity Management, Authentication, and Access Control, as well as Data security / Protective Technology, Information Protection Processes and Procedures, Awareness Training and Maintenance.',
  },
  section1_subsec2_ques1: {
    id: 'T8k5RJ',
    defaultMessage:
      'To what extent are there established identity, authentication, and access control procedures in place?',
  },
  section1_subsec2_ques2: {
    id: 'k23hAl',
    defaultMessage:
      'How well are you implementing data security measures for protecting sensitive data at rest, in transit, and in use?',
  },
  section1_subsec2_ques3: {
    id: 'nTd9bB',
    defaultMessage:
      'To what extent are there procedures in place to regularly conduct audits and maintain systems securely?',
  },

  //section 2
  section2: {
    id: '5WaoTy',
    defaultMessage: 'Detect & Respond',
  },
  section2_ques: {
    id: 'xBKsOU',
    defaultMessage:
      'How often do you run vulnerability scans and penetration testing?',
  },
  section2_ans1: {
    id: 'du1laW',
    defaultMessage: 'Never',
  },
  section2_ans1_desc: {
    id: 'HzoLqF',
    defaultMessage:
      'The following questions can help you understand why this is important and some best practice steps you can take. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section2_ans2: {
    id: '8TmUj4',
    defaultMessage: 'Rarely',
  },
  section2_ans2_desc: {
    id: 'GvO+Up',
    defaultMessage:
      'The following questions can help you identify the areas that should be monitored and regularly tested and to establish effective policies to manage this. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section2_ans3: {
    id: 'AkIyKO',
    defaultMessage: "I don't know",
  },
  section2_ans3_desc: {
    id: '/QckUH',
    defaultMessage:
      'The following questions can help you to establish what your current threat detection and testing posture is and to identify initial areas for improvement. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section2_ans4: {
    id: 'Iud+o+',
    defaultMessage: 'Often',
  },
  section2_ans4_desc: {
    id: 'pOpAsu',
    defaultMessage:
      'The following questions can help you to validate your understanding of elements that require continuous monitoring for threat detection and regular testing and to identify possible areas of improvement. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section2_ans5: {
    id: 'Jb7naT',
    defaultMessage: 'Regularly',
  },
  section2_ans5_desc: {
    id: 'AaBAL0',
    defaultMessage:
      'The following questions can help you verify the effectiveness of your threat detection and test processes. Our team can guide you to maintain this position in the future. Our team can guide you to maintain this position in the future. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section2_subsec1_quesName: {
    id: 'EES7Oc',
    defaultMessage: 'Detect',
  },
  section2_subsec1_feature_desc: {
    id: 'UyckgV',
    defaultMessage:
      'Threat detection is crucial for maintaining robust cyber resilience, as it enables you to identify potential security threats and respond effectively to mitigate damage and prevent future attacks.  Our study will look at Anomalies and Events, Detection Processes and Security Continuous Monitoring.',
  },
  section2_subsec1_ques1: {
    id: 'lfWaJ4',
    defaultMessage:
      'Do you ensure the continued stability and effectiveness of your security policies and intrusion detection systems through regular maintenance, testing, and review processes?',
  },
  section2_subsec1_ques2: {
    id: '9LQh5T',
    defaultMessage:
      'How well can you detect dormant and active threats in your storage and backup environments?',
  },
  section2_subsec1_ques3: {
    id: '3Sxg0a',
    defaultMessage:
      'How well do you analyse and understand the root cause of cyber incidents? ',
  },
  section2_subsec2_quesName: {
    id: 'PgVsJy',
    defaultMessage: 'Respond',
  },
  section2_subsec2_feature_desc: {
    id: 'Ac2Buj',
    defaultMessage:
      'A well-designed cyber resilience strategy prioritizes response, enabling you to effectively manage security incidents and minimize damage when breaches occur.  Our study looks at Response Planning, Response Communications, Analysis, Mitigation and Improvements.',
  },
  section2_subsec2_ques1: {
    id: 'kstFho',
    defaultMessage:
      'How effectively do you manage response plans and resources to address cybersecurity incidents, ensuring clear communication, role identification, incident containment, and regular contingency plan reviews?',
  },
  section2_subsec2_ques2: {
    id: 'd9vds/',
    defaultMessage:
      'How well are you implementing real-time data security monitoring to detect and respond to potential threats?',
  },

  //section 3
  section3: {
    id: 'UIVqKu',
    defaultMessage: 'Recover',
  },
  section3_ques: {
    id: 'Fx8Om4',
    defaultMessage:
      'In the event of a cyberattack do you know how long it would take to make your company operational again?',
  },
  section3_ans1: {
    id: 'dtvR8X',
    defaultMessage: 'Definitely Not',
  },
  section3_ans1_desc: {
    id: 'TPpzIe',
    defaultMessage:
      'The following questions can help you understand the principles you need to consider to implement an effective cyber recovery plan. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section3_ans2: {
    id: 'Dw1TFB',
    defaultMessage: 'Probably Not',
  },
  section3_ans2_desc: {
    id: 'Or4jpp',
    defaultMessage:
      'The following questions can help you understand the principles you need to consider to implement an effect cyber recovery plan. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section3_ans3: {
    id: 'AkIyKO',
    defaultMessage: "I don't know",
  },
  section3_ans3_desc: {
    id: 'AfvENA',
    defaultMessage:
      'The following questions can help you to establish what your current cyber recovery posture is and to identify initial areas for improvement. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section3_ans4: {
    id: 'X2C1T3',
    defaultMessage: 'Probably',
  },
  section3_ans4_desc: {
    id: '9PUwvf',
    defaultMessage:
      'The following questions can help you to validate your understanding of your current cyber recovery plan is and to identify possible areas for improvement. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section3_ans5: {
    id: '5xP/dz',
    defaultMessage: 'Definitely',
  },
  section3_ans5_desc: {
    id: 'jr403R',
    defaultMessage:
      'If you believe you can successfully recover in the event of an attack, our team can help you validate this and help you to maintain this position in the future. Our in-depth study will provide a holistic view of your overall cyber preparedness.',
  },
  section3_subsec1_quesName: {
    id: 'UIVqKu',
    defaultMessage: 'Recover',
  },
  section3_subsec1_feature_desc: {
    id: 'ne8R9J',
    defaultMessage:
      'Only one in seven companies can fully recover data from backups following a cyberattack. A swift response helps contain potential breaches, reduces downtime, and safeguards sensitive information, thereby preserving organizational reputation and trust among stakeholders. Our study looks at Recovery, Recovery Planning, Improving your recovery plan and Recovery Communications.',
  },
  section3_subsec1_ques1: {
    id: 'CKiO+o',
    defaultMessage:
      'How effectively do you test and maintain your business continuity / business recovery procedures, including contingency recovery plans and ransomware preparedness, ensuring thorough testing and communication with stakeholders?',
  },
  section3_subsec1_ques2: {
    id: '0TIxgP',
    defaultMessage:
      'How effectively can you ensure the integrity of your backup systems and ensure backup copies are malware free, for example using a Clean Room implementation?',
  },
  section3_subsec1_ques3: {
    id: 'zvu/LP',
    defaultMessage:
      'How quickly can you identify the best data copy for recovery ("golden Copy")?',
  },
  section3_subsec1_ques4: {
    id: 'tQBpdz',
    defaultMessage:
      'How well do you believe your infrastructure can handle mass recovery after a large scale cyber attack?',
  },

  //section 4
  section4: {
    id: 'NIi2K2',
    defaultMessage: 'Compliance',
  },
  section4_ques: {
    id: 'VPP0PZ',
    defaultMessage:
      'Are your solutions compliant with relevant industry security standards?',
  },
  section4_ans1: {
    id: 'dtvR8X',
    defaultMessage: 'Definitely Not',
  },
  section4_ans1_desc: {
    id: 'o04s63',
    defaultMessage:
      'Our team can help you ensure compliance with the essential standards appropriate to your region and industry.',
  },
  section4_ans2: {
    id: 'Dw1TFB',
    defaultMessage: 'Probably Not',
  },
  section4_ans2_desc: {
    id: 'o04s63',
    defaultMessage:
      'Our team can help you ensure compliance with the essential standards appropriate to your region and industry.',
  },
  section4_ans3: {
    id: 'AkIyKO',
    defaultMessage: "I don't know",
  },
  section4_ans3_desc: {
    id: 'o04s63',
    defaultMessage:
      'Our team can help you ensure compliance with the essential standards appropriate to your region and industry.',
  },
  section4_ans4: {
    id: 'X2C1T3',
    defaultMessage: 'Probably',
  },
  section4_ans4_desc: {
    id: 'o04s63',
    defaultMessage:
      'Our team can help you ensure compliance with the essential standards appropriate to your region and industry.',
  },
  section4_ans5: {
    id: '5xP/dz',
    defaultMessage: 'Definitely',
  },
  section4_ans5_desc: {
    id: 'o04s63',
    defaultMessage:
      'Our team can help you ensure compliance with the essential standards appropriate to your region and industry.',
  },
  section4_subsec1_quesName: {
    id: 'NIi2K2',
    defaultMessage: 'Compliance',
  },
  section4_subsec1_feature_desc: {
    id: 'sSRqcC',
    defaultMessage:
      'Threat identification is crucial for building robust cyber resilience, as it enables you to proactively address potential vulnerabilities before they can be exploited, thereby minimizing the impact of security breaches and ensuring business continuity.  Our study looks at the areas of Asset Management, Business Environment, Governance, Risk Assessment and Risk Management Strategy.',
  },

  text_right: {
    id: 'GCJSK9',
    defaultMessage:
      'This assessment study will work through your cyber readiness in more detail with respect to the following areas.',
  },
  cta: {
    id: 'TclprG',
    defaultMessage: 'Download PDF',
  },

  option_not_all: {
    id: 'zArQLV',
    defaultMessage: 'Not at all',
  },
  option_throughly: {
    id: '5OC+NX',
    defaultMessage: 'Thoroughly',
  },
  option_never: {
    id: 'du1laW',
    defaultMessage: 'Never',
  },
  option_very: {
    id: 'FM97dD',
    defaultMessage: 'Very',
  },
  option_regularly: {
    id: 'Jb7naT',
    defaultMessage: 'Regularly',
  },
  option_continuously: {
    id: 'AmTk9H',
    defaultMessage: 'Continuously',
  },
  option_quickly: {
    id: 'u9dxBl',
    defaultMessage: 'Very Quickly',
  },

  // number messages
  number_1: {
    id: 'Tf9Oo0',
    defaultMessage: '1',
  },
  number_2: {
    id: 'QLJEES',
    defaultMessage: '2',
  },
  number_3: {
    id: 'O6+/CI',
    defaultMessage: '3',
  },
  number_4: {
    id: 'oyHYtA',
    defaultMessage: '4',
  },
  number_5: {
    id: 'Bt8FNx',
    defaultMessage: '5',
  },

  // pdf
  pdf_page1_heading: {
    id: 'y5UXRj',
    defaultMessage: 'High Level Security & Resilience Assessment Report',
  },
  pdf_page1_client: {
    id: 'EnbyI1',
    defaultMessage: 'Client: ',
  },
  pdf_page1_business: {
    id: 'SWi5iE',
    defaultMessage: 'Business Partner: ',
  },
  pdf_page2_heading: {
    id: '9uOFF3',
    defaultMessage: 'Overview',
  },
  pdf_page2_desc: {
    id: '+EzuKk',
    defaultMessage:
      "This report provides a strategic, high-level overview of your current cybersecurity and resilience posture. It is designed to serve as a starting point for enhancing the organization's ability to withstand, respond to, and recover from cyber incidents. The insights presented are based on responses to the online Cyber Resilience Assessment tool and reflect key themes across governance, risk management, and operational readiness. While this report highlights important areas for attention, it is not intended to serve as a comprehensive or prescriptive planning document.&lt;br&gt;&lt;br&gt;For a deeper, consultative analysis, including tailored recommendations and solution strategies, IBM offers the no-cost, vendor-agnostic Security and Resilience Assessment. Our experts can work directly with your teams to identify and address gaps, strengthen controls, and align your resilience strategy with business objectives and regulatory expectations.",
  },
  pdf_page_score: {
    id: 'oLkLww',
    defaultMessage: 'Score',
  },
  pdf_page3_heading: {
    id: '2WWihC',
    defaultMessage: 'Your Results',
  },
  pdf_page3_section1_h: {
    id: 'izvHMl',
    defaultMessage: 'Identify',
  },
  pdf_page3_section1_desc: {
    id: 'odUtkY',
    defaultMessage:
      'Foundational practices are in place for identifying cybersecurity risks, but further development is needed to ensure full visibility and strategic alignment. This includes strengthening Asset Management through a complete inventory of systems, applications, and data, and mapping them to business-critical functions. The Business Environment should be clearly documented, including defining the "Minimum Viable Company" - the essential components required to maintain operations during a crisis. Governance structures must support accountability and oversight, while Risk Assessment and Risk Management Strategy should be enhanced to include the financial implications of cyber incidents, enabling better prioritization of controls and investments.&lt;br&gt;&lt;br&gt;&lt;b&gt;Key Recommendations: &lt;/b&gt;&lt;br&gt;Establish a centralized asset inventory, define the minimum viable company, assess financial impact of incidents, formalize governance, and align risk strategy with business priorities.',
  },
  pdf_page3_section2_h: {
    id: '8JGaVE',
    defaultMessage: 'Protect',
  },
  pdf_page3_section2_desc: {
    id: 'YUQw9e',
    defaultMessage:
      'Implementing robust security measures is crucial for maintaining a strong cyber resilience posture, as it helps safeguard sensitive data, protect against potential threats, and ensure business continuity during times of crisis or disruption. Protective measures are in place but require greater consistency and alignment with business priorities. In Identity Management and Access Control, enforce least privilege and multi-factor authentication across all systems. Awareness and Training programs should be regularly updated and tailored to roles. Data Security must include encryption at rest and in transit, with a roadmap toward quantum-safe encryption. Information Protection Processes and Procedures should be documented and automated where possible. Maintenance practices must ensure timely updates and patching. Protective Technology should be prioritized based on the criticality of assets to business operations, and immutable copies should be implemented to safeguard data integrity.&lt;br&gt;&lt;br&gt;&lt;b&gt;Key Recommendations: &lt;/b&gt;&lt;br&gt;Strengthen access controls, enhance training, implement quantum-safe and immutable data protection, automate procedures, and align protection efforts with asset criticality.',
  },
  pdf_page4_section: {
    id: 'd+tm2/',
    defaultMessage: 'Your Results (continued)',
  },
  pdf_page4_section1_h: {
    id: 'EES7Oc',
    defaultMessage: 'Detect',
  },
  pdf_page4_section1_desc: {
    id: 'KIZxCq',
    defaultMessage:
      'Threat detection is crucial for maintaining robust cyber resilience, as it enables you to identify potential security threats and respond effectively to mitigate damage and prevent future attacks.Detection capabilities are present but need to be expanded for real-time responsiveness and broader coverage. In Anomalies and Events, define baselines and thresholds to detect deviations early—since early detection reduces damage and accelerates recovery. Security Continuous Monitoring should cover all critical infrastructure, including cloud and remote endpoints. Detection Processes must be standardized and integrated with response workflows. Correlation of events from multiple sources - such as logs, network traffic, and endpoint data - can reduce false positives and improve situational awareness.&lt;br&gt;&lt;br&gt;&lt;b&gt;Key Recommendations: &lt;/b&gt;&lt;br&gt;Deploy real-time anomaly detection, expand monitoring coverage, correlate multi-source events, and integrate detection with response systems.',
  },
  pdf_page4_section2_h: {
    id: 'PgVsJy',
    defaultMessage: 'Respond',
  },
  pdf_page4_section2_desc: {
    id: 'kDxXNC',
    defaultMessage:
      'A well-designed cyber resilience strategy prioritises response, enabling you to effectively manage security incidents and minimise damage when breaches occur. Response planning and execution require greater maturity to ensure coordinated and compliant incident handling. Response Planning should include detailed playbooks for various incident types. Communications protocols must be clear and tested, both internally and externally. Analysis capabilities should support root cause investigation and impact assessment. Mitigation strategies must be predefined and rehearsed. Improvements should be driven by post-incident reviews. Importantly, response plans must account for legal and regulatory obligations to report incidents to authorities, ensuring compliance and transparency.&lt;br&gt;&lt;br&gt;&lt;b&gt;Key Recommendations: &lt;/b&gt;&lt;br&gt;Develop and test playbooks, establish communication protocols, enhance forensic analysis, define mitigation procedures, and ensure regulatory reporting readiness.',
  },
  pdf_page4_section3_h: {
    id: 'UIVqKu',
    defaultMessage: 'Recover',
  },
  pdf_page4_section3_desc: {
    id: 'jEI89I',
    defaultMessage:
      'Only one in seven companies can fully recover data from backups following a cyberattack. A swift response helps contain potential breaches, reduces downtime, and safeguards sensitive information, thereby preserving organisational reputation and trust among stakeholders. Operational recovery processes need to be strengthened to ensure resilience and compliance. Recovery Planning should include cyber-specific scenarios and align with business continuity objectives. Improvements must be based on recovery testing and incident outcomes. Recovery Communications should ensure stakeholders are informed during and after restoration. Periodic recovery testing is not only a best practice but may also be a regulatory or legal requirement, especially in regulated industries. Implementing immutable backups, validating restore processes and recovery data in sandbox environments will improve confidence and reliability.&lt;br&gt;&lt;br&gt;&lt;b&gt;Key Recommendations: &lt;/b&gt;&lt;br&gt;Define RTO/RPO targets for cyber incidents, implement immutable backups, validate data integrity, conduct regular recovery testing, and maintain clear recovery communication plans.',
  },
  pdf_page5_heading: {
    id: 'eZ7pw0',
    defaultMessage: 'Overall Assessment Score',
  },
  pdf_page5_scoreKey: {
    id: 'tdLV2v',
    defaultMessage: 'Scoring Key',
  },
  pdf_page5_score1_label: {
    id: 'HKH6Mq',
    defaultMessage: '0 - 29%',
  },
  pdf_page5_score1_desc: {
    id: 'syvXs4',
    defaultMessage: 'There are little or no controls in place.',
  },
  pdf_page5_score2_label: {
    id: 'e4XctM',
    defaultMessage: '30 - 59%',
  },
  pdf_page5_score2_desc: {
    id: 'ZnrWe9',
    defaultMessage:
      'Base practices of the control are generally performed on an ad-hoc basis. There is general agreement within the organisation that identified actions should be performed and they are performed when required.',
  },
  pdf_page5_score3_label: {
    id: '7Y/Oht',
    defaultMessage: '60 - 79%',
  },
  pdf_page5_score3_desc: {
    id: 'tcP4uw',
    defaultMessage:
      'The controls are planned, implemented, tracked and reported on. Defined practices and governance are generally in place.',
  },
  pdf_page5_score4_label: {
    id: 'sAlXYl',
    defaultMessage: '80 - 99%',
  },
  pdf_page5_score4_desc: {
    id: 'Rn7WSt',
    defaultMessage:
      'The controls are planned, implemented, tracked and reported on. In addition practices are repeatable and the processes used are Mature: Documented, approved, and implemented organisation-wide.',
  },
  pdf_page5_score5_label: {
    id: '8ZVfG8',
    defaultMessage: '100%',
  },
  pdf_page5_score5_desc: {
    id: '9my6Cf',
    defaultMessage:
      'Controls are implemented, processes are highly mature, practices mastered over several years, adaptive and quantitively measured (Industry Leading)',
  },
  pdf_page5_footnote: {
    id: 'jHNJJz',
    defaultMessage:
      '*Please note that the above definitions are based on a more in-depth consultative assessment and your particular result from this tool should not be considered definitive. &lt;br&gt;&lt;strong&gt; Click here to request a full assessment: &lt;/strong&gt;',
  },
  pdf_page5_footnoteBtn: {
    id: 'yHjzT8',
    defaultMessage: 'Request a full assessment',
  },
  chart_ideal: {
    id: 'cDuDFs',
    defaultMessage: 'Ideal',
  },
  chart_user: {
    id: 'EwRIOm',
    defaultMessage: 'User',
  },
});
export default messages;
